<template>
	<!-- <q-ajax-bar position="top" ref="bar" size="5px" :delay="delay" color="$secondary" /> -->
	<splash v-show="isLoading" title="어휘학습 준비중..." />
	<splash v-show="isProc" title="잠시만 기다려 주세요." />
	<!-- <q-layout v-show="!isLoading" view="hHh lpR fFf"> -->
	<studyHeader v-if="!isLoading" />
	<q-page-container v-show="!isLoading">
		<ul class="qlist">
			<div class="question" v-html="questionHeader"></div>
			<li class="list_item" v-for="(item, index) in data" :key="item.problemId">
				<div style="display: flex; flex-direction: row">
					<div style="display: flex; flex-direction: column; width: 100%">
						<div
							style="
								display: flex;
								flex-direction: row;
								width: 100%;
								justify-content: space-between;
							"
						>
							<div style="display: flex">
								<div class="number">
									<div
										v-show="complete"
										:class="[
											item.correctYn === true
												? 'marking-correct'
												: 'marking-wrong',
										]"
									/>
									{{ index + 1 }}.
								</div>
								<div style="font-size: 1.4em" v-html="item.problems"></div>
							</div>
							<div v-if="visibleAnswer">{{ data[index].correct }}</div>
							<div class="icon_box">
								<div
									v-show="!complete"
									:class="[
										answer &&
										answer.filter(
											item => item.index === index + 1 && item.checked === '①'
										).length > 0
											? 'checked'
											: 'icon_circle',
									]"
									@click="selectAnswer(index + 1, '①')"
								>
									<CusButton
										:type="
											answer &&
											answer.filter(
												item => item.index === index + 1 && item.checked === '①'
											).length === 0
												? 361
												: 380
										"
									/>
								</div>
								<div
									v-show="complete && item.correctYn"
									:class="[
										answer &&
										answer.filter(
											item => item.index === index + 1 && item.checked === '①'
										).length > 0
											? 'checked'
											: 'icon_circle',
									]"
								>
									<CusButton
										:type="
											answer &&
											answer.filter(
												item => item.index === index + 1 && item.checked === '①'
											).length > 0
												? 391
												: 361
										"
									/>
								</div>
								<div
									v-show="complete && !item.correctYn"
									:class="[
										answer &&
										answer.filter(
											item => item.index === index + 1 && item.checked === '①'
										).length === 0
											? 'icon_circle'
											: 'wrong_answer_circle',
									]"
								>
									<CusButton
										:type="
											answer &&
											answer.filter(
												item => item.index === index + 1 && item.checked === '①'
											).length === 0
												? 361
												: 391
										"
									/>
								</div>
								<div
									v-show="!complete"
									:class="[
										answer &&
										answer.filter(
											item => item.index === index + 1 && item.checked === '②'
										).length > 0
											? 'checked_wrong'
											: 'icon_circle',
									]"
									@click="selectAnswer(index + 1, '②')"
								>
									<CusButton
										:type="
											answer &&
											answer.filter(
												item => item.index === index + 1 && item.checked === '②'
											).length === 0
												? 370
												: 390
										"
									/>
								</div>
								<div
									v-show="complete && item.correctYn"
									:class="[
										answer &&
										answer.filter(
											item => item.index === index + 1 && item.checked === '②'
										).length > 0
											? 'checked_wrong'
											: 'icon_circle',
									]"
								>
									<CusButton
										:type="
											answer &&
											answer.filter(
												item => item.index === index + 1 && item.checked === '②'
											).length === 0
												? 370
												: 392
										"
									/>
								</div>
								<div
									v-show="complete && !item.correctYn"
									:class="[
										answer &&
										answer.filter(
											item => item.index === index + 1 && item.checked === '②'
										).length === 0
											? 'icon_circle'
											: 'wrong_answer_circle',
									]"
								>
									<CusButton
										:type="
											answer &&
											answer.filter(
												item => item.index === index + 1 && item.checked === '②'
											).length === 0
												? 370
												: 392
										"
									/>
								</div>
							</div>
						</div>
						<div class="check_answer" v-show="complete">
							<div
								style="display: flex; flex-direction: row; align-items: center"
							>
								<span style="font-weight: 700; font-size: 1.2em">정답</span>
								<div
									:class="
										item.correct === '②'
											? 'checked_small_wrong'
											: 'checked_small'
									"
								>
									<q-icon
										:name="
											item.correct === '①' ? 'radio_button_unchecked' : 'close'
										"
										size="1.5em"
										class="checkedicon"
									/>
									<!-- <q-icon v-if="item.correct === '②'" name="close" size="1em" class='checkedicon' /> -->
								</div>
							</div>
							<div
								style="
									margin-top: 10px;
									display: flex;
									flex-direction: row;
									align-items: center;
								"
							>
								<span style="font-weight: 700; font-size: 1.2em">해설</span>
								<span
									style="margin-left: 10px; font-size: 1.2em"
									v-html="item.explain"
								></span>
							</div>
						</div>
					</div>
				</div>
				<div class="divider" />
			</li>
		</ul>
		<FloatingNotify
			:text="msg"
			@resetMsg="
				() => {
					msg = '';
				}
			"
		/>
		<FloatingBtn
			:visible="nextBtn && !complete"
			text="정답 확인"
			@on-click="
				() => {
					testPaper();
				}
			"
			bgColor="#FF4E7C"
			class="answer--txt"
		/>
		<FloatingBtn
			:visible="complete"
			:text="completeTitle"
			@on-click="
				() => {
					showPopup();
				}
			"
			bgColor="#222222"
			icon="done"
			class="answer--txt"
		/>
		<!-- <q-footer bordered class="bg-white text-primary"> -->
		<!-- <div class="bottom_buttons">
        <div style="display: flex; flex-direction: row; width: 10%; justify-content: space-between;">
          <button class="button_icon">
            <q-icon name="chevron_left" size="3em" style="color: #fff" />
          </button>
          <button class="button_icon">
            <q-icon name="chevron_right" size="3em" style="color: #fff" />
          </button>
        </div>
      </div> -->
		<!-- </q-footer> -->
	</q-page-container>
	<!-- </q-layout> -->
	<modalLayer v-if="store.visibleModal" :width="'30%'">
		<div class="popup">
			<h5 style="font-weight: 700">어휘학습 완료!</h5>
			<img
				src="@/assets/images/ready.png"
				style="width: 70%; margin-top: 20px"
			/>
			<div style="font-size: 1.2em">다음은 비문학-지문2의</div>
			<div style="font-size: 1.2em">코어독해 학습을 시작합니다.</div>
			<button class="move_to_core" @click="moveToCoreReading">
				코어독해 시작
			</button>
		</div>
	</modalLayer>
</template>

<script setup>
import { historyBack } from '@/helpers/utils';
import splash from '@/components/template/splash.vue';
import { ref, onMounted, onUnmounted, watch } from 'vue';
import studyHeader from '@/components/layouts/header/studyHeader.vue';
import { useQuasar } from 'quasar';
import { useRouter, useRoute } from 'vue-router';
import { getKrtExam, getKrtProblem } from '@/api/modules/qbank';
import dataToParse from '@/helpers/qbankParser/dataParse';
import moment from 'moment';
import modalLayer from '@/components/layouts/layer/modalLayer.vue';
import { DialogStore } from '@/store/modules/dialog';
import {
	getHeader,
	getQuestion,
	getQuestion_old,
	getAnswerExplain,
} from '@/helpers/qbankParser/qbankDataParse';
import { stripTags } from '@amcharts/amcharts5/.internal/core/util/Utils';
import { StudyStore } from '@/store/modules/study';
import {
	postAnswer,
	getLessonNext,
	postCornerEnd,
	checkProgress,
	getAnswer,
} from '@/api/modules/study';
import { getUserMain, postUserJson } from '@/api/modules/login';
import * as zzApi from '@/api/modules/login';

import FloatingBtn from '@/components/quasar/floatingBtn.vue';
import FloatingNotify from '@/components/quasar/floatingNotify.vue';
import _ from 'lodash';
import { soundEffect } from '@/helpers/soundEffect';
import CusButton from '@/components/widget/CusButton.vue';
import { learningType } from '@/helpers/qbankParser/qbankMeta';

import {
	monitoringLog,
	monitoringTodayLearningStudy,
} from '@/api/modules/monitoring';

const isLog = true;

const router = useRouter();
const route = useRoute();

const loadingTime = 1000;
const isLoading = ref(null);
const isProc = ref(null);
const delay = 0;
// const bar = ref(null)
const answer = ref([]);
const complete = ref(false);
const $q = useQuasar();
const isVisiblePopup = ref(false);
const store = DialogStore();
const studyStore = StudyStore();
const dStore = DialogStore();
const data = ref(null);
const questionHeader = ref(null);

const msg = ref('');
const nextBtn = ref(false);

let noti = null;
let problemMaps = [];
let temp = [];
let i = 0;
let isDone = false;

let stage = ''; // start, check, done

let cornerTime = {
	cornerLearningStartTs: null,
	cornerLearningEndTs: null,
	cornerLearningTime: 0,
};
let cornerLearningBaseTime = null;
let startTime;
let currentIdx = 0;

let isViewMode = false;
let endApiCall = false;
const completeTitle = ref('지문1학습 완료');
const visibleAnswer = ref(false);

const initVoca = (rs, sdata = null) => {
	let value = {
		question: getHeader(rs, true),
		problems: getQuestion_old(rs),
		// answer: rs.content.solution.answer.detail[0].answer,
		correct: rs.content.solution.answer.detail[0].answer,
		explain: getAnswerExplain(rs),
		problemId: rs.content.problemId,
		answerStartTs: null,
		answerEndTs: null,
		elapsedTime: 0,
		// correct: null,
		answer: '',
		reAnswer: null,
		reCorrectFlag: null,
		correctYn: null,
		problemClassCode: '1',
		reviewContents: null,
		cornerStartTs: null,
		cornerEndTs: null,
		cornerElapsedTime: null,
		// problems: styletag(dataToParse.getQuestionBody(rs)[0][0].content),
		// answer: dataToParse.getAnswer(rs)[2].content,
		// explain: dataToParse.getAnswerExplain(rs)[0][0].content
	};
	if (sdata) {
		const tmpData = [...sdata]
			.filter(i => i.problemId === rs.content.problemId)
			.pop();
		if (tmpData) {
			value = {
				...value,
				completeYn: tmpData.completeYn,
				elapsedTime: tmpData.elapsedTime,
				answer: tmpData.answer,
				checked: tmpData.answer,
				correctYn: tmpData.correctYn,
				reAnswer: tmpData.reAnswer,
				reCorrectYn: tmpData.reCorrectYn,
				result: {
					marking: tmpData.correctYn
						? 'right'
						: tmpData.reCorrectYn
						? 'halfRight'
						: 'wrong',
					answer: tmpData.correctYn ? tmpData.answer : tmpData.reAnswer,
				},
				answerStartTs: tmpData.answerStartTs,
				answerEndTs: tmpData.answerEndTs,
				problemClassCode: tmpData.problemClassCode,
				cornerStartTs: tmpData.cornerStartTs,
				cornerEndTs: tmpData.cornerEndTs,
				cornerElapsedTime: tmpData.cornerElapsedTime,
			};
		}
	}
	temp.push(value);
	// console.log(value)
	// console.log(temp)

	questionHeader.value = null; //2023-11-07 pby 문제 데이터 초기화 추가.
	if (isLog) console.log('voc befor: ' + questionHeader.value);
	if (temp.length === 4) {
		data.value = _.sortBy(temp, 'problemId');
		isLoading.value = false;
		// if (bar.value) {
		//   bar.value.stop()
		// }

		startTime = moment();
		if (isLog)
			console.log('처음 진입시간 ', moment().format('YYYY-MM-DD HH:mm:ss'));
		cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
		//cornerLearningBaseTime = moment();
	}
	// data.value = temp;
	// questionHeader.value = dataToParse.getQuestionHeader(rs);
	questionHeader.value = stripTags(getHeader(rs, true));
	if (isLog) console.log('voc after: ' + questionHeader.value);
};

const testPaper = () => {
	//정답 확인할때 코너 종료 시간 추가
	complete.value = true;
	const cornerEndTs = moment();
	cornerTime.cornerLearningEndTs = cornerEndTs.format('YYYY-MM-DD HH:mm:ss');
	cornerTime.cornerLearningTime = moment
		.duration(cornerEndTs.diff(moment(cornerTime.cornerLearningStartTs)))
		.asMilliseconds();
	let newData = [];
	// if (isLog) console.log('-어휘--testPaper 7777- :');
	answer.value.map((item, index) => {
		item.answerStartTs = item.answerStartTs.format('YYYY-MM-DD HH:mm:ss');
		item.answerEndTs = item.answerEndTs.format('YYYY-MM-DD HH:mm:ss');
	});
	data.value.map((item, index) => {
		answer.value.map(ans => {
			if (index === ans.index - 1) {
				if (item.correct === ans.checked) {
					// if (isLog) console.log('-어휘--testPaper 8888- :');
					let temp = {
						...item,
						correctYn: true,
						answer: ans.checked,
					};
					return newData.push(temp);
				} else {
					// if (isLog) console.log('-어휘--testPaper 9999- :');
					let temp = {
						...item,
						correctYn: false,
						answer: ans.checked,
					};
					return newData.push(temp);
				}
			}
		});
	});

	// if (isLog) console.log('-어휘--testPaper 6666- :');
	data.value = newData;

	if (answer.value.length === data.value.length) {
		nextBtn.value = false;
		complete.value = true;
		setTimeout(() => {
			nextBtn.value = true;
		}, 1000);
		// noti = $q.notify({
		//   color: 'light-blue-7',
		//   textColor: 'white',
		//   multiLine: true,
		//   position: 'bottom-right',
		//   badgeStyle: { display: 'none' },
		//   timeout: 0,
		//   actions:
		//     [{ label: '학습완료', color: 'white', handler: () => showPopup() }]
		// })
	}
	return;
};

const showPopup = () => {
	// isVisiblePopup.value = true
	// store.openModal(true)
	// saveResult();
	if (!isDone) {
		window.scroll({
			top: 300,
		});
		isProc.value = true;
		isDone = true;
		submitAnswer();
	}
	// if (studyStore.mapTree.exams.length > studyStore.process.examIdx) {
	//   // 다음 지문으로 이동
	//   // studyStore.setNextProcess();
	//   // moveToCoreReading();
	//   // studyStore.process = { exam: studyStore.mapTree.exams[studyStore.process + 1], examIdx: studyStore.process + 1, studyTree: 5082, problemOrd: 0, isDone: false }
	// } else if (studyStore.mapTree.exams.length === studyStore.process.examIdx) {
	//   // TODO: 학습 완료 프로세스 진행
	// }
};

const submitAnswer = async num => {
	let tmpRs = [];
	if (!isViewMode) {
		checkProgress(rs => {
			//2023-01-04 pby KRT-2190 추천학습중 맞춤학습 진도가 변경된 경우 학습 알럿 표출 안함
			const learningTypeCodeFlag =
				learningType[studyStore.process.exam.learningType].code;
			if (rs.modifyProgressFlag && learningTypeCodeFlag == '1') {
				dStore.openAlertDialog({
					//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
					//message: '학습 진도가 ' + (rs.modifyProgressFlag ? '수정' : '리셋') + '되었습니다.\n 다시 학습을 진행해 주세요.',
					//2023-12-11 pby KRT-2153 -- 학습중 진도수정시 알럿 메세지 수정.
					message: '학습 진도가 변경되었습니다. ',
					buttonText: '확인',
					callback: () => {
						//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
						router.push('/learninghome');
						// sendUserAnswer(end, saveData);
						// postAnswer({ type: 'core', data: saveData }, () => {
						//     studyStore.process.exam.learningStatus = 'I';
						//     if (end) saveResult();
						// });
					},
				});
				//2024-01-04 pby 반영확인
			} else if (rs.modifyProgressFlag && learningTypeCodeFlag == '6') {
				dStore.openAlertDialog({
					//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
					//message: '학습 진도가 ' + (rs.modifyProgressFlag ? '수정' : '리셋') + '되었습니다.\n 다시 학습을 진행해 주세요.',
					//2023-12-11 pby KRT-2153 -- 학습중 진도수정시 알럿 메세지 수정.
					message:
						'학습 진도가 수정되었습니다. 현재 학습이 끝나면 진도가 변경됩니다.',
					buttonText: '확인',
					callback: () => {},
				});
			}
			//2024-01-04 pby 반영확인
		});

		let totalElapsedTime = 0;
		await Promise.all(
			answer.value.map((i, index) => {
				let item = { ...i };
				const _data = {
					examName: studyStore.process.exam.examCode + '_W',
					exprVersion: studyStore.exprVersion,
					learningType: studyStore.process.exam.learningType,
					cornerTime: {
						cornerLearningStartTs: item.answerStartTs,
						cornerLearningEndTs: item.answerEndTs,
						cornerLearningTime: item.elapsedTime,
					},
					submission: item,
				};
				if (isLog)
					console.log('-어휘--postAnswer parameter- :', JSON.stringify(_data));
				return postAnswer(
					{
						type: 'vocabulary',
						data: _data,
					},
					() => {
						if (isLog)
							console.log('-어휘--submitAnswer 11111-DB전달값 :', _data);
					}
				);
			})
		);
		saveResult();
	} else {
		if (isLog) console.log('-어휘--submitAnswer 22222- :');

		store.openAlertDialog({
			message: '현재 진행중인 학습으로 이동합니다.',
			cancel: '닫기',
			ok: '확인',
			callback: () => {
				studyStore.currentInfo = null;
				router.push(
					studyStore.process.studyTree === 5083
						? '/authenticreading'
						: studyStore.process.studyTree === 5084
						? '/vocabularylearning'
						: 'corereading'
				);
			},
		});
	}
};
const saveResult = () => {
	if (!endApiCall) {
		endApiCall = true;
		postCornerEnd(
			{
				type: 'vocabulary',
				data: {
					examName: studyStore.process.exam.examCode + '_W',
					learningType: studyStore.process.exam.learningType,
				},
			},
			() => {
				getLessonNext(
					{ learningHistorySeq: studyStore.process.learningHistorySeq },
					async r => {
						// const fIndex = _.findIndex(studyStore.mapTree.exams, function (o) { return o.examCode === rs.nextStart.examName.slice(0, rs.nextStart.examName.length - 2); });
						// studyStore.process.examIdx = fIndex;
						// studyStore.process.studyTree = 5082;
						// studyStore.process.problemOrd = 0;
						// studyStore.process.exam = {
						//   examCode: rs.nextStart.examName.slice(0, rs.nextStart.examName.length - 2),
						//   version: studyStore.mapTree.exams[fIndex]?.exprVersion,
						//   // TODO: 변경해야함
						//   headerEtcCd02: rs.nextStart.areaCode === '01' ? '05' : '02',
						//   headerEtcCd01: studyStore.mapTree.exams[fIndex]?.headerEtcCd01,
						//   title: studyStore.mapTree.exams[fIndex]?.title,
						//   areaCode: rs.nextStart.areaCode,
						//   isDone: false,
						//   learningType: rs.nextStart.learningType,
						//   learningStatus: studyStore.mapTree.exams[fIndex].learningStatus,
						// };

						if (r.areaEndFlag) {
							// if (r.lastCompleteType === 'SUGGESTION_DIAGNOSTIC') {
							//   studyStore.report.learningHistorySeqs = r?.learningHistorySeqs;
							// } else {
							//   studyStore.report.learningHistorySeqs = null;
							// }
							studyStore.report.learningHistorySeqs = r?.learningHistorySeqs;
							studyStore.report.level = studyStore.process.exam?.level;
							studyStore.report.lesson = studyStore.process.exam?.lesson;
							studyStore.report.areaCode = studyStore.process.exam.areaCode;
							// TODO: 추천학습 맞춤학습이 확정되면 수정 필요
							studyStore.report.learningTypeCode =
								learningType[studyStore.process.exam.learningType].code;
							studyStore.report.learningType =
								studyStore.process.exam.learningType;
						}

						// if (r.lessonEndFlag) {
						//   // 레슨 종료 처리
						//   getUserMain((rs) => {
						//     let tmpMapTree = [];
						//     // let tmpStudy = { '01': [], '02': [] };
						//     rs.studyMain.forEach(element => {
						//       // tmpStudy[element.areaCode] = [...tmpStudy[element.areaCode], element];
						//       tmpMapTree.push({
						//         // examCode: element.learningType !== 'SAT' ? element.examName.slice(0, element.examName.length - 2) : element.examName,
						//         examCode: element.examName,
						//         version: rs.exprVersion,
						//         // TODO: 변경해야함
						//         headerEtcCd02: element.areaCode === '01' ? '05' : '02',
						//         headerEtcCd01: element.passageClass,
						//         passageClass: element.passageClass,
						//         area: element.areaCode === '01' ? '문학' : '비문학',
						//         title: element.passageName,
						//         areaCode: element.areaCode,
						//         isDone: false,
						//         learningStatus: element.learningStatus,
						//         learningType: element.learningType,
						//         difficult: element.areaCode === '01' ? JSON.parse(element.difficultyL) : JSON.parse(element.difficultyN),
						//         satOrder: element?.satOrder ? element?.satOrder : null,
						//         level: element?.level,
						//         lesson: element?.lesson
						//       });
						//     });
						//     studyStore.level = rs.level;
						//     studyStore.lesson = rs.lesson;
						//     studyStore.exprVersion = rs.exprVersion;
						//     studyStore.mapTree.exams = tmpMapTree;
						//     // studyStore.difficultyL = JSON.parse(rs.difficultyL);
						//     // studyStore.difficultyN = JSON.parse(rs.difficultyN);

						//     const fIndex = _.findIndex(rs.studyMain, function (o) { return o.examName === rs.currentStart.examName; });
						//     studyStore.process.examIdx = fIndex;
						//     if (rs.studyMain[fIndex].learningStatus === 'W') {
						//       studyStore.process.studyTree = 5082;
						//     }
						//     studyStore.process.problemOrd = 0;
						//     studyStore.process.exam = {
						//       // examCode: rs.currentStart.learningType !== 'SAT' ? rs.currentStart.examName.slice(0, rs.currentStart.examName.length - 2) : rs.currentStart.examName,
						//       examCode: rs.currentStart.examName,
						//       version: rs.exprVersion,
						//       // TODO: 변경해야함
						//       headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
						//       headerEtcCd01: rs.studyMain[fIndex].headerEtcCd01,
						//       passageClass: rs.studyMain[fIndex].passageClass,
						//       area: rs.currentStart.areaCode === '01' ? '문학' : '비문학',
						//       title: rs.studyMain[fIndex].passageName,
						//       areaCode: rs.currentStart.areaCode,
						//       isDone: false,
						//       learningType: rs.currentStart.learningType,
						//       learningStatus: rs.studyMain[fIndex]?.learningStatus,
						//       difficult: rs.currentStart.areaCode === '01' ? JSON.parse(rs.studyMain[fIndex]?.difficultyL) : JSON.parse(rs.studyMain[fIndex]?.difficultyN),
						//       satOrder: rs.currentStart?.satOrder ? rs.currentStart?.satOrder : null,
						//       level: rs.currentStart?.level,
						//       lesson: rs.currentStart?.lesson
						//     };

						//     // postUserJson(JSON.stringify(studyStore.process), (rs) => {
						//     //   //
						//     // });
						//     if (r.areaEndFlag) {
						//       // 결과 보고서로 이동

						//       return router.push('/dailyreport');
						//     } else {
						//       if (r.nextStart?.learningType === 'SAT' || r.nextStart?.learningType === 'SAT_RESET') {
						//         return router.push('/sat');
						//       } else {
						//         return router.push('/corereading');
						//       }
						//     }
						//   });
						// } else {
						//   // const fIndex = _.findIndex(studyStore.mapTree.exams, function (o) { return o.examCode === r.nextStart.examName.slice(0, r.nextStart.examName.length - 2); });
						//   const fIndex = _.findIndex(studyStore.mapTree.exams, function (o) { return o.examCode === r.nextStart.examName; });
						//   studyStore.process.examIdx = fIndex;
						//   studyStore.process.studyTree = 5082;
						//   studyStore.process.problemOrd = 0;
						//   studyStore.process.exam = {
						//     // examCode: r.nextStart?.learningType !== 'SAT' ? r.nextStart.examName.slice(0, r.nextStart.examName.length - 2) : r.nextStart.examName,
						//     examCode: r.nextStart.examName,
						//     version: studyStore.mapTree.exams[fIndex]?.exprVersion,
						//     // TODO: 변경해야함
						//     headerEtcCd02: r.nextStart.areaCode === '01' ? '05' : '02',
						//     headerEtcCd01: studyStore.mapTree.exams[fIndex]?.headerEtcCd01,
						//     title: r.nextStart.passageName,
						//     passageClass: r.nextStart.passageClass,
						//     area: r.nextStart.areaCode === '01' ? '문학' : '비문학',
						//     areaCode: r.nextStart.areaCode,
						//     isDone: false,
						//     learningType: r.nextStart?.learningType,
						//     learningStatus: r.nextStart?.learningStatus,
						//     difficult: studyStore.mapTree.exams[fIndex]?.difficult,
						//     satOrder: studyStore.mapTree.exams[fIndex]?.satOrder ? studyStore.mapTree.exams[fIndex]?.satOrder : null,
						//     level: studyStore.mapTree.exams[fIndex]?.level,
						//     lesson: studyStore.mapTree.exams[fIndex]?.lesson
						//   };
						//   postUserJson(JSON.stringify(studyStore.process), (rs) => {
						//     //
						//   });
						//   if (r.areaEndFlag) {
						//     // 결과 보고서로 이동
						//     return router.push('/dailyreport');
						//   } else {
						//     if (learningType)
						//       return router.push('/corereading');
						//   }
						// }

						// 레슨 종료 처리

						/* KRT-1587 */
						const res = await zzApi.getUserMain2();
						if (res && res.status === 200) {
							const rs = res.data.data;
							let tmpMapTree = [];
							// let tmpStudy = { '01': [], '02': [] };
							rs.studyMain.forEach(element => {
								// tmpStudy[element.areaCode] = [...tmpStudy[element.areaCode], element];
								tmpMapTree.push({
									// examCode: element.learningType !== 'SAT' ? element.examName.slice(0, element.examName.length - 2) : element.examName,
									examCode: element.examName,
									version: rs.exprVersion,
									// TODO: 변경해야함
									headerEtcCd02: element.areaCode === '01' ? '05' : '02',
									headerEtcCd01: element.passageClass,
									passageClass: element.passageClass,
									area: element.areaCode === '01' ? '문학' : '비문학',
									title: element.passageName,
									areaCode: element.areaCode,
									isDone: false,
									learningStatus: element.learningStatus,
									learningType: element.learningType,
									difficult:
										element.areaCode === '01'
											? JSON.parse(element.difficultyL)
											: JSON.parse(element.difficultyN),
									satOrder: element?.satOrder ? element?.satOrder : null,
									groupIndex: element?.groupIndex ? element?.groupIndex : null,
									level: element?.level,
									lesson: element?.lesson,
								});
							});
							studyStore.level = rs.level;
							studyStore.lesson = rs.lesson;
							studyStore.exprVersion = rs.exprVersion;
							studyStore.mapTree.exams = tmpMapTree;
							// studyStore.difficultyL = JSON.parse(rs.difficultyL);
							// studyStore.difficultyN = JSON.parse(rs.difficultyN);

							const fIndex = _.findIndex(rs.studyMain, function (o) {
								return o.examName === rs.currentStart.examName;
							});
							studyStore.process.examIdx = fIndex;
							if (rs.studyMain[fIndex].learningStatus === 'W') {
								studyStore.process.studyTree = 5082;
							}
							studyStore.process.problemOrd = 0;
							studyStore.process.exam = {
								// examCode: rs.currentStart.learningType !== 'SAT' ? rs.currentStart.examName.slice(0, rs.currentStart.examName.length - 2) : rs.currentStart.examName,
								examCode: rs.currentStart.examName,
								version: rs.exprVersion,
								// TODO: 변경해야함
								headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
								headerEtcCd01: rs.studyMain[fIndex].headerEtcCd01,
								passageClass: rs.studyMain[fIndex].passageClass,
								area: rs.currentStart.areaCode === '01' ? '문학' : '비문학',
								title: rs.studyMain[fIndex].passageName,
								areaCode: rs.currentStart.areaCode,
								isDone: false,
								learningHistorySeq: rs.currentStart.learningHistorySeq,
								learningType: rs.currentStart.learningType,
								learningStatus: rs.studyMain[fIndex]?.learningStatus,
								difficult:
									rs.currentStart.areaCode === '01'
										? JSON.parse(rs.studyMain[fIndex]?.difficultyL)
										: JSON.parse(rs.studyMain[fIndex]?.difficultyN),
								satOrder: rs.currentStart?.satOrder
									? rs.currentStart?.satOrder
									: null,
								groupIndex: rs.currentStart?.groupIndex
									? rs.currentStart?.groupIndex
									: null,
								level: rs.currentStart?.level,
								lesson: rs.currentStart?.lesson,
							};
							// postUserJson(JSON.stringify(studyStore.process), (rs) => {
							//   //
							// });

							//k.u.j 성장판 2.0 오늘의 학습 api call
							monitoringTodayLearningStudy({
								learningHistorySeq: studyStore.process.exam.learningHistorySeq,
								eventTypeCode: 3,
							});

							if (r.areaEndFlag) {
								// 결과 보고서로 이동

								return router.push('/dailyreport');
							} else {
								if (
									r.nextStart?.learningType === 'SAT' ||
									r.nextStart?.learningType === 'SAT_RESET'
								) {
									return router.push('/sat');
								} else {
									return router.push('/corereading');
								}
							}
						}
						// getUserMain((rs) => {
						//     let tmpMapTree = [];
						//     // let tmpStudy = { '01': [], '02': [] };
						//     rs.studyMain.forEach((element) => {
						//         // tmpStudy[element.areaCode] = [...tmpStudy[element.areaCode], element];
						//         tmpMapTree.push({
						//             // examCode: element.learningType !== 'SAT' ? element.examName.slice(0, element.examName.length - 2) : element.examName,
						//             examCode: element.examName,
						//             version: rs.exprVersion,
						//             // TODO: 변경해야함
						//             headerEtcCd02: element.areaCode === '01' ? '05' : '02',
						//             headerEtcCd01: element.passageClass,
						//             passageClass: element.passageClass,
						//             area: element.areaCode === '01' ? '문학' : '비문학',
						//             title: element.passageName,
						//             areaCode: element.areaCode,
						//             isDone: false,
						//             learningStatus: element.learningStatus,
						//             learningType: element.learningType,
						//             difficult: element.areaCode === '01' ? JSON.parse(element.difficultyL) : JSON.parse(element.difficultyN),
						//             satOrder: element?.satOrder ? element?.satOrder : null,
						//             groupIndex: element?.groupIndex ? element?.groupIndex : null,
						//             level: element?.level,
						//             lesson: element?.lesson,
						//         });
						//     });
						//     studyStore.level = rs.level;
						//     studyStore.lesson = rs.lesson;
						//     studyStore.exprVersion = rs.exprVersion;
						//     studyStore.mapTree.exams = tmpMapTree;
						//     // studyStore.difficultyL = JSON.parse(rs.difficultyL);
						//     // studyStore.difficultyN = JSON.parse(rs.difficultyN);

						//     const fIndex = _.findIndex(rs.studyMain, function (o) {
						//         return o.examName === rs.currentStart.examName;
						//     });
						//     studyStore.process.examIdx = fIndex;
						//     if (rs.studyMain[fIndex].learningStatus === 'W') {
						//         studyStore.process.studyTree = 5082;
						//     }
						//     studyStore.process.problemOrd = 0;
						//     studyStore.process.exam = {
						//         // examCode: rs.currentStart.learningType !== 'SAT' ? rs.currentStart.examName.slice(0, rs.currentStart.examName.length - 2) : rs.currentStart.examName,
						//         examCode: rs.currentStart.examName,
						//         version: rs.exprVersion,
						//         // TODO: 변경해야함
						//         headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
						//         headerEtcCd01: rs.studyMain[fIndex].headerEtcCd01,
						//         passageClass: rs.studyMain[fIndex].passageClass,
						//         area: rs.currentStart.areaCode === '01' ? '문학' : '비문학',
						//         title: rs.studyMain[fIndex].passageName,
						//         areaCode: rs.currentStart.areaCode,
						//         isDone: false,
						//         learningType: rs.currentStart.learningType,
						//         learningStatus: rs.studyMain[fIndex]?.learningStatus,
						//         difficult: rs.currentStart.areaCode === '01' ? JSON.parse(rs.studyMain[fIndex]?.difficultyL) : JSON.parse(rs.studyMain[fIndex]?.difficultyN),
						//         satOrder: rs.currentStart?.satOrder ? rs.currentStart?.satOrder : null,
						//         groupIndex: rs.currentStart?.groupIndex ? rs.currentStart?.groupIndex : null,
						//         level: rs.currentStart?.level,
						//         lesson: rs.currentStart?.lesson,
						//     };

						//     // postUserJson(JSON.stringify(studyStore.process), (rs) => {
						//     //   //
						//     // });
						//     if (r.areaEndFlag) {
						//         // 결과 보고서로 이동

						//         return router.push('/dailyreport');
						//     } else {
						//         if (r.nextStart?.learningType === 'SAT' || r.nextStart?.learningType === 'SAT_RESET') {
						//             return router.push('/sat');
						//         } else {
						//             return router.push('/corereading');
						//         }
						//     }
						// });
					}
				);
			}
		);
	}
};

const moveToCoreReading = () => {
	router.push('/corereading');
};
const selectAnswer = (idx, checked) => {
	stage.value === 'check';
	// 클릭 시간 저장
	const clickTime = moment();
	// 만약 이 문제가 이미 클릭되었다면
	const existingProblem = answer.value.find(p => p.index === idx);
	if (existingProblem) {
		// 풀이를 종료하고, 종료 시간과 풀이 시간을 저장
		existingProblem.answerEndTs = clickTime;
		existingProblem.elapsedTime = existingProblem.answerEndTs.diff(
			existingProblem.answerStartTs,
			'milliseconds'
		);
		existingProblem.correct = data.value[idx - 1].correct;
		existingProblem.answer = checked === '①' ? '①' : '②';
		existingProblem.checked = checked;
		existingProblem.correctYn =
			checked === data.value[idx - 1].correct ? true : false;
	} else {
		// 이 문제가 아직 클릭 안됐다면, 문제와 시간을 저장
		const problemTimeData = {
			index: idx,
			answerStartTs: startTime,
			elapsedTime: clickTime.diff(startTime, 'milliseconds'),
			answerEndTs: clickTime,
			problemId: data.value[idx - 1].problemId,
			correct: data.value[idx - 1].correct,
			answer: checked === '①' ? '①' : '②',
			checked: checked,
			correctYn: checked === data.value[idx - 1].correct ? true : false,
			problemClassCode: data.value[idx - 1].problemClassCode,
		};
		answer.value.push(problemTimeData);
	}
	startTime = moment();
	if (complete.value === true) {
		return;
	}
	if (temp.length == answer.value.length) {
		nextBtn.value = false;
		setTimeout(() => {
			nextBtn.value = true;
		}, 100);
	}
};

const init = () => {
	temp = [];
	isLoading.value = true;
	// const barRef = bar.value;
	// barRef.start()
	stage.value === 'start';
	if (studyStore.currentInfo !== null) {
		isViewMode = true;
		complete.value = true;
		nextBtn.value = true;
		completeTitle.value = '완료';
		getAnswer(
			{
				type: 'vocabulary',
				data: {
					examName: studyStore.currentInfo.exam.examCode,
					learningType: studyStore.currentInfo.exam.learningType,
				},
			},
			rAnswer => {
				const sortAnswer = _.sortBy(rAnswer, 'problemId');
				answer.value = sortAnswer.map((item, index) => {
					return {
						index: index + 1,
						checked: item.answer,
					};
				});
				setTimeout(() => {
					getKrtExam(
						{
							version: studyStore.exprVersion,
							examNm: studyStore.currentInfo.exam.examCode + '_W',
						},
						rs => {
							if (rs.examMaps) {
								const exId = rs.examIds[0];
								problemMaps = rs.examMaps[exId];
								problemMaps.map(item => {
									getKrtProblem(
										{
											version: studyStore.exprVersion,
											problemId: item.problemId,
										},
										r => {
											initVoca(r, rAnswer);
										}
									);
								});
							}
						}
					);
				}, 1000);
			}
		);
	} else {
		if (studyStore.process.examIdx === 1 || studyStore.process.examIdx === 3) {
			completeTitle.value = '분석리포트 확인';
		} else if (
			studyStore.mapTree.exams[studyStore.process.examIdx + 1]
				?.learningStatus === 'C'
		) {
			// 1번 지문 리셋일 경우 1번지문 완료 후에도 바로 리포트 이동
			completeTitle.value = '분석리포트 확인';
		}

		setTimeout(() => {
			// msg.value = '어휘력 실력을 키워보아요!';
			msg.value = '수능 빈출 어휘 문제를 풀어 보세요.';
		}, [2000]);

		setTimeout(() => {
			getKrtExam(
				{
					version: studyStore.exprVersion,
					examNm: studyStore.process.exam.examCode + '_W',
				},
				rs => {
					if (rs.examMaps) {
						const exId = rs.examIds[0];
						problemMaps = rs.examMaps[exId];
						problemMaps.map(item => {
							getKrtProblem(
								{
									version: studyStore.exprVersion,
									problemId: item.problemId,
								},
								initVoca
							);
						});
					}
				}
			);
		}, 1000);
	}
};
onMounted(() => {
	init();
	setTimeout(() => {
		let data = {
			menuName: route.path.split('/').join(''),
			learningTypeCode: learningType[studyStore.process.exam.learningType].code,
			examName: studyStore.process.exam.examCode + '_W',
			groupIndex: studyStore?.suggestionIdx,
		};
		monitoringLog(data, res => {
			console.log('vocabularylearning monitoringLog API response ===', res);
		});
	}, 1200);
	if (
		process.env.NODE_ENV === 'local' ||
		process.env.NODE_ENV === 'development' ||
		localStorage.getItem('videoSuperPass')
	) {
		visibleAnswer.value = true;
	}
});

watch(
	() => studyStore.currentInfo,
	newValue => {
		data.value = null;
		temp = [];
		answer.value = [];
		isLoading.value = true;
		complete.value = false;
		nextBtn.value = false;
		isViewMode = false;
		isDone = false;
		// const barRef = bar.value;
		// barRef.start()
		stage.value === 'start';
		if (newValue !== null) {
			isViewMode = true;
			complete.value = true;
			nextBtn.value = true;
			completeTitle.value = '완료';
			getAnswer(
				{
					type: 'vocabulary',
					data: {
						examName: newValue.exam.examCode,
						learningType: newValue.exam.learningType,
					},
				},
				rAnswer => {
					answer.value = rAnswer.map((item, index) => {
						return {
							index: index + 1,
							checked: item.answer,
						};
					});
					setTimeout(() => {
						getKrtExam(
							{
								version: studyStore.exprVersion,
								examNm: newValue.exam.examCode + '_W',
							},
							rs => {
								if (rs.examMaps) {
									const exId = rs.examIds[0];
									problemMaps = rs.examMaps[exId];
									problemMaps.map(item => {
										getKrtProblem(
											{
												version: studyStore.exprVersion,
												problemId: item.problemId,
											},
											r => {
												initVoca(r, rAnswer);
											}
										);
									});
								}
							}
						);
					}, 1000);
				}
			);
		} else {
			if (
				studyStore.process.examIdx === 1 ||
				studyStore.process.examIdx === 3
			) {
				completeTitle.value = '분석리포트 확인';
			} else if (
				studyStore.mapTree.exams[studyStore.process.examIdx + 1]
					?.learningStatus === 'C'
			) {
				// 1번 지문 리셋일 경우 1번지문 완료 후에도 바로 리포트 이동
				completeTitle.value = '분석리포트 확인';
			}
			/*
            setTimeout(() => {
                // msg.value = '어휘력 실력을 키워보아요!';
                msg.value = '수능 빈출 어휘 문제를 풀어 보세요.';
            }, [2000]);
             */
			setTimeout(() => {
				getKrtExam(
					{
						version: studyStore.exprVersion,
						examNm: studyStore.process.exam.examCode + '_W',
					},
					rs => {
						if (rs.examMaps) {
							const exId = rs.examIds[0];
							problemMaps = rs.examMaps[exId];
							problemMaps.map(item => {
								getKrtProblem(
									{
										version: studyStore.exprVersion,
										problemId: item.problemId,
									},
									initVoca
								);
							});
						}
					}
				);
			}, 1000);
		}
	}
);

watch(answer, () => {
	if (answer.value?.length === data.value?.length) {
		!nextBtn.value && (msg.value = '문제를 다 풀었어요!');
		nextBtn.value = true;
	}
});

onUnmounted(() => {
	isLoading.value = true;
	// noti !== null && noti();
	data.value = null;
	temp = [];
	answer.value = [];
	complete.value = false;
	endApiCall = false;
});
</script>

<style scoped lang="scss">
.question {
	// margin-left: 120px;
	font-size: 1.5em;
	font-weight: 700;
	// margin-top: 30px;
}

.qlist {
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 40px 120px;
	height: 80%;
}

.list_item {
	display: flex;
	flex-direction: column;
	padding-top: 12px;

	.number {
		justify-content: center;
		display: flex;
		align-items: flex-start;
		margin-top: 16px;
		font-size: 1.5rem;
		font-weight: bold;
		margin-right: 24px;
	}
}

.icon_box {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.icon_circle {
	width: 70px;
	height: 70px;
	border-radius: 50%;
	border: 1px solid #bbbbbb60;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 20px;
}

.divider {
	width: 100%;
	height: 1px;
	background-color: $divider;
	margin-top: 12px;
}

.bottom_buttons {
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 60px;
	justify-content: center;
	align-items: center;
}

.button_icon {
	width: 40px;
	height: 40px;
	background-color: #bbbbbb70;
	border-radius: 50%;
}

.check_answer {
	width: calc(100% - 56px);
	background-color: $gray_200;
	border-radius: 16px;
	margin-top: 12px;
	margin-bottom: 12px;
	padding: 20px;
	margin-left: 56px;
}

.checked {
	width: 70px;
	height: 70px;
	border-radius: 50%;
	border: 1px solid #bbbbbb60;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 20px;
	background-color: #4659ff;
}

.checked_wrong {
	width: 70px;
	height: 70px;
	border-radius: 50%;
	border: 1px solid #bbbbbb60;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 20px;
	// background-color: $primary;
	background-color: #ef2b2a;
}

.move_to_core {
	background-color: $primary;
	padding: 10px 16px;
	border-radius: 20px;
	color: $white;
	margin-top: 20px;
	font-weight: 600;
}

.checked_small {
	width: 30px;
	height: 30px;
	border-radius: 50%;
	border: 1px solid #bbbbbb60;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 10px;
	background-color: #4659ff;

	&_wrong {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		border: 1px solid #bbbbbb60;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 10px;
		background-color: #ef2b2a;
	}
}

.checkedicon {
	color: #fff;
}

.uncheckedicon {
	color: #d9d9d9;
}

.popup {
	width: 100%;
	background-color: $white;
	border-radius: 30px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 50px 25px;
	min-height: 460px;
	max-height: 550px;
}

.marking {
	&-correct {
		background-image: url('@/assets/images/O.png');
		background-position: 50%;
		background-size: cover;
		width: 90px;
		height: 90px;
		position: absolute;
		z-index: 100;
		margin-top: -22px;
		margin-left: 0px;
	}

	&-hcorrect {
		background-image: url('@/assets/images/OX.png');
		background-position: 50%;
		width: 90px;
		height: 90px;
		position: absolute;
		z-index: 100;
		margin-top: -22px;
		margin-left: 0px;
	}

	&-wrong {
		background-image: url('@/assets/images/X.png');
		background-position: 50%;
		background-size: cover;
		width: 90px;
		height: 90px;
		position: absolute;
		z-index: 100;
		margin-top: -22px;
		margin-left: 0px;
	}

	&-fwrong {
		background-image: url('@/assets/images/XX.png');
		background-position: 50%;
		background-size: cover;
		width: 90px;
		height: 90px;
		position: absolute;
		z-index: 100;
		margin-top: -22px;
		margin-left: 0px;
	}
}

.answer {
	&--txt {
		padding: 2.75vmin 3.42vmin !important;
		margin-right: 3.33vmin;
		font-size: 1.2vw;
		font-weight: 700;
		line-height: 1.6vw;
	}
}

.wrong_answer_circle {
	width: 70px;
	height: 70px;
	border-radius: 50%;
	border: 1px solid#BDBDBD;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 20px;
	background-color: #bdbdbd;
}
</style>
